package com.dotdrives.web.ui

import com.dotdrives.design.DotTone
import react.FC
import react.Props
import react.dom.html.ReactHTML.span
import web.cssom.ClassName

internal fun DotTone.classSuffix(): String = name.lowercase()

external interface DotPillProps : Props {
    var text: String
    var tone: DotTone?
    var className: String?
}

val DotPill = FC<DotPillProps> { props ->
    val tone = props.tone ?: DotTone.Neutral
    span {
        className = ClassName(
            listOfNotNull("dot-pill", "dot-tone-${tone.classSuffix()}", props.className).joinToString(" "),
        )
        +props.text
    }
}
